module.exports = __webpack_public_path__ + "img/occupancy-rate-w.svg";